// Vendors
import * as PIXI from 'pixi.js'

export class ReleaseBlock extends PIXI.Container {
    public isRelease: boolean;
    public zIndex: number = 100;
    public isNeedToOpen: boolean;
    constructor() {
        super();
    }
}